import HTMLReactParser from "html-react-parser";
import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import avatar from "../../assets/images/avatar-temp.png";
import { formatToPostDate, isGovernorateEmperor } from "../../lib/commonFunctions";
import { DragescentState } from "../../store/reducers/stateType";
import PostForm from "../Common/PostForm";
import { CHAT_TYPE, POST_CONTEXT } from "../../lib/enums";
import { getChatPosts } from "../../store/actions";
import SubMenu from "../Menu/SubMenu";

const replacements = [
  { picture: "p_smich", code: "{{smm" },
  { picture: "p_heh", code: "{{sml" },
  { picture: "p_buu", code: "{{sad" },
  { picture: "p_ooo", code: "{{hmm" },
  { picture: "p_grr", code: "{{grr" },
  { picture: "p_hul", code: "{{smk" },
  { picture: "p_baba", code: "{{xyz" },
  { picture: "p_kenny", code: "{{ken" },
  { picture: "p_bum", code: "{{bmb" },
  { picture: "p_smrt", code: "{{dth" },
  { picture: "p_srdce", code: "{{lv" },
  { picture: "p_snek", code: "{{snk" },
  { picture: "p_prdel", code: "{{sht" },
  { picture: "p_pulitr", code: "{{pul" },
  { picture: "p_ovce", code: "{{ovc" },
  { picture: "p_fuck", code: "{{fck" },
  { picture: "p_ok", code: "{{up" },
  { picture: "p_ko", code: "{{dwn" },
  { picture: "p_vict", code: "{{vct" }
]

const replaceImages = (content: string) => {
  let replaced = content;
  // @ts-ignore
  replacements.map(r => replaced = replaced
    .replace(
      new RegExp(`<img\\s+src=\"\/images\/emoticons\/${r.picture}\.gif\"\\s+width="19"\\s+height="19">`, "g"),
      r.code
    ));
  replaced = replaced.replace(/<br>/g, "\n");
  replaced = replaced.replace(new RegExp("<font color=red><b>([^<\/b><\/font>]+)<\/b><\/font>", "g"), `{b{$1{bb{`);
  replaced = replaced.replace(new RegExp("<u>([^<\\//w>]+)<\/u>", "g"), `{u{$1{uu{`);
  replaced = replaced.replace(new RegExp("<i>([^<\\//w>]+)<\/i>", "g"), `{i{$1{ii{`);

  return replaced;
}

const AllianceBoard = () => {
  const [editMode, setEditMode] = useState<boolean>(false);

  const id = useSelector((state: DragescentState) => state.governorate.id);
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const commander = useSelector((state: DragescentState) => state.governorate.commander);
  const board = useSelector(
    (state: DragescentState) => state.governorate.chatPosts && state.governorate.chatPosts[0]
  );
  const dispatch = useDispatch();

  const textAreaRef = createRef<HTMLTextAreaElement>();

  useEffect(() => {
    dispatch(getChatPosts(CHAT_TYPE.Board));
  }, []);

  return (
    <>
    <SubMenu
      tabs={[
        {
          name: "Chat",
          title: "Alliance Chat",
          icon: "politika",
          label: "Alliance Chat",
          active: false,
          disabled: !alliance,
          parameters: {
            type: CHAT_TYPE.Alliance,
          }
        },
        {
          name: "Chat",
          title: "World Chat",
          icon: "politika",
          label: "World Chat",
          active: false,
          parameters: {
            type: CHAT_TYPE.Public,
          }
        },
        {
          name: "AllianceBoard",
          title: "Alliance board",
          icon: "statistiky",
          label: "Alliance board",
          active: true
        }
      ]}
    />

      <h2 className="h2 h2-first">
        <span className="bordered">Board</span>
      </h2>
      <span className="divider"/>

    <section className="boxes-group">
      <div className="box first">
        <div className="comments" id="comments">
          <div className="comment" id="alliance-board">
            <header className="comment-header clearfix">
              <span className="user">
                  <img src={avatar} alt="Dragon avatar" className="avatar"/>
                {board && <>
                <strong className="gubernate">
                      Last edited:
                  </strong>
                  <small>({formatToPostDate(new Date(board.postDate.timestamp * 1000))})</small>
                </>
                }
              </span>
            </header>
            <div className="comment-body clearfix">
              <p>{board
                ? HTMLReactParser(board.content)
                : "Alliance board is empty. Emperor or marshal can add important information for alliance members, here."}
              </p>
              <div className="row">
                <div className="col-md-push-9 col-xs-6 col-sm-4 col-lg-3 actions reactions text-right">
                  {(commander || isGovernorateEmperor(id, alliance))
                  && <a
                    className="item link"
                    data-toggle="slide"
                    onClick={() => setEditMode(!editMode)}
                  >
                    {editMode ? "Cancel edit" : "Edit board"}
                  </a>}
                </div>
              </div>
              {editMode
               && <PostForm
                context={POST_CONTEXT.Chat}
                chatType={CHAT_TYPE.Board}
                textAreaRef={textAreaRef}
                presetText={board ? replaceImages(board.content) : undefined}
              />}
            </div>
          </div>
        </div>
      </div>
      <span className="divider"/>
    </section>
    </>
  )
}

export default AllianceBoard;
